export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~5],
		"/about": [6],
		"/blog": [~7],
		"/blog/[slug]": [~8],
		"/changelog": [~9],
		"/changelog/[slug]": [~10],
		"/contact": [11],
		"/customers": [12],
		"/docs": [13,[2]],
		"/docs/contact-support": [~15,[2]],
		"/docs/faq": [~16,[2]],
		"/docs/tags": [17,[2]],
		"/docs/tags/[tag]": [~18,[2]],
		"/docs/troubleshooting": [~19,[2]],
		"/docs/[...slug]": [~14,[2,3]],
		"/faq": [20],
		"/features": [21],
		"/features/absence": [22],
		"/features/clients": [23],
		"/features/communication": [24],
		"/features/files": [25],
		"/features/finance": [26],
		"/features/invoicing": [27],
		"/features/notes": [28],
		"/features/people": [29],
		"/features/project-management": [30],
		"/features/pulse": [31],
		"/features/reports": [32],
		"/features/tasks": [33],
		"/features/team-support": [34],
		"/features/time-tracking": [35],
		"/features/todos": [36],
		"/getting-started": [37],
		"/guides": [38,[4]],
		"/guides/[slug]": [~39,[4]],
		"/integrations": [40],
		"/press-kit": [42],
		"/press": [~41],
		"/pricing": [43],
		"/privacy-policy": [44],
		"/products": [~45],
		"/products/cli": [46],
		"/products/extensions": [47],
		"/products/mobile": [48],
		"/products/web": [49],
		"/search": [~50],
		"/sitemap": [51],
		"/stories": [~52],
		"/stories/[slug]": [~53],
		"/team": [54],
		"/terms-of-use": [55],
		"/weekly": [~56],
		"/weekly/author/[author]": [~57],
		"/weekly/blog": [~58],
		"/weekly/blog/[slug]": [~59]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';